// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6f66310d","130":"9fe89706","149":"65f091cf","156":"f699d5ca","181":"74711140","283":"74264e67","372":"6f53de07","378":"93a95957","408":"46f549b7","437":"34f25f71","596":"6cbcc3eb","789":"e55d4156","839":"0bfc8a87","942":"213193db"}[chunkId] + ".chunk.js";
};